import Phaser from 'phaser'

export default class Score extends Phaser.GameObjects.Container {
  constructor (scene, player) {
    super(scene, 100, 80)

    const bg1 = this.scene.add.image(0, 0, 'white').setTint(0).setDisplaySize(450, 100).setRotation(0.03)
    this.add(bg1)
    const bg2 = this.scene.add.image(-20, 60, 'white').setTint(0).setDisplaySize(340, 60).setRotation(0.08)
    this.add(bg2)

    const score = this.scene.add.image(0, 0, 'hud', 'score')
    this.add(score)
    const combo = this.scene.add.image(0, 50, 'hud', 'combo')
    this.add(combo)

    const scoreText = this.scene.add.text(80, -20, '0', {
      color: 'white',
      fontSize: '32pt',
      fontStyle: 'bold'
    })
    this.add(scoreText)
    const comboText = this.scene.add.text(60, 32, 'x1', {
      color: 'white',
      fontSize: '24pt',
      fontStyle: 'bold'
    })
    this.add(comboText)

    this.setAlpha(0)
    this.scene.player.once('has-moved', () => this.scene.tweens.add({ targets: this, alpha: 1, duration: 240, delay: 400 }))

    this.multiplier = 1
    player.on('hit', () => {
      player.score = Math.max(0, player.score + this.multiplier * 10)
      this.multiplier = Math.min(10, this.multiplier + 1)
      player.emit('score-changed', player.score)
    })
    player.on('missed', () => {
      this.multiplier = 1
      comboText.setText(`x${this.multiplier}`)
    })

    player.on('score-changed', score => {
      scoreText.setText(score.toString())
      comboText.setText(`x${this.multiplier}`)
    })

    const resize = () => {
      if (this.scene) {
        this.x = 100 - (this.scene.scale.width - 1280) / 2
      }
    }
    this.scene.scale.on('resize', resize)
    resize()
  }
}
